// components/CustomToast.jsx
import { BiSolidErrorAlt } from "react-icons/bi";
import { BsFillPatchCheckFill } from "react-icons/bs";
import { FiCheck } from "react-icons/fi";
import { FiExternalLink } from "react-icons/fi";
import { PiSealWarningFill } from "react-icons/pi";

const CustomToast = ({ message,type }) => {
    return (
        <div className="w-full flex text-[#2E0F33]">
            <div className="flex items-center  w-[17%] ">
                <div className="bg-[#F3F0F5] p-2 rounded-full">
                    {type == 'Success' ?
                        <BsFillPatchCheckFill className="text-[#2E0F33]" size={23} />
                        : type == 'Warn' ? <PiSealWarningFill className="text-[orange]" size={23} />
                            :
                            <BiSolidErrorAlt className="text-[red]" size={23} />}
                </div>
            </div>
            <span className="text-sm w-[70%] self-center">{message}</span>
            <div className="flex items-center  w-[15%] ">

            <div className="bg-[#F3F0F5] p-2 rounded-full ml-1 ">
                <FiExternalLink className="text-[#A3A3A3]" />
            </div>
            </div>
        </div>
    );
};

export default CustomToast;
